import { Dropdown, DropdownItem } from '@frontend/components/common';
import React from 'react';
import { LuEllipsis } from 'react-icons/lu';

interface PaginationNumberProps {
    id?: string;
    index: number;
    disabled?: boolean | ((index: number) => boolean);
    highlighted: boolean | ((index: number) => boolean);
    onClick: (index: number) => void;
    styles?: {
        highlighted?: string;
        default?: string;
        disabled?: string;
    };
    pageDropdown?: boolean;
    pageCount?: number;
}

export const PaginationNumberLiClass =
    'self-stretch size-12 px-4 py-3 bg-background-surface rounded-xl outline outline-1 outline-offset-[-1px] outline-border-default inline-flex justify-center items-center gap-2 cursor-pointer hover:bg-background-default';
export const PaginationNumberLiClassHighlighted =
    'self-stretch text-background-surface size-12 px-4 py-3 bg-brand-primary rounded-xl inline-flex justify-center items-center gap-2 cursor-not-allowed';
export const PaginationNumberLiClassDisabled =
    'self-stretch size-12 px-4 py-3 rounded-xl inline-flex justify-center items-center gap-2 cursor-not-allowed bg-background-default';

export const PaginationNumber = (props: PaginationNumberProps) => {
    const isDisabled = props.disabled === undefined ? false : typeof props.disabled === 'boolean' ? props.disabled : props.disabled(props.index);
    const isHighlighted = typeof props.highlighted === 'boolean' ? props.highlighted : props.highlighted(props.index);

    const liClass = isDisabled
        ? (props?.styles?.disabled ?? PaginationNumberLiClassDisabled)
        : isHighlighted
          ? (props?.styles?.highlighted ?? PaginationNumberLiClassHighlighted)
          : (props?.styles?.default ?? PaginationNumberLiClass);

    if (props.pageDropdown) {
        return (
            <Dropdown
                hideChevron
                buttonStyle={liClass}
                icon={LuEllipsis}
                iconClass='me-0'>
                {Array.from({ length: (props.pageCount ?? 0) - props.index }).map((_, i) => (
                    <DropdownItem
                        key={i + props.index}
                        label={i + props.index}
                        onClick={() => props.onClick(i + props.index)}
                        disabled={isDisabled}
                    />
                ))}
            </Dropdown>
        );
    }
    return (
        <li
            id={props.id + '-pagination-number-' + props.index}
            className={liClass}
            onClick={isDisabled ? undefined : () => props.onClick(props.index)}>
            {props.pageDropdown ? '...' : props.index}
        </li>
    );
};
